export const getDifficultyAndBlooms = (blooms: string, difficulty: string) => {
  let btl = ''
  let severity = null
  //find severity
  if (
    (blooms === 'Knowledge' && difficulty === 'Basic') ||
    (blooms === 'Knowledge' && difficulty === 'Easy') ||
    (blooms === 'Knowledge' && difficulty === 'Medium') ||
    (blooms === 'Understanding' && difficulty === 'Basic') ||
    (blooms === 'Understanding' && difficulty === 'Easy') ||
    (blooms === 'Application' && difficulty === 'Basic')
  ) {
    severity = 1
  } else if (
    (blooms === 'Knowledge' && difficulty === 'Hard') ||
    (blooms === 'Understanding' && difficulty === 'Medium') ||
    (blooms === 'Application' && difficulty === 'Easy')
  ) {
    severity = 2
  } else if ((blooms === 'Understanding' && difficulty === 'Hard') || (blooms === 'Application' && difficulty === 'Medium')) {
    severity = 3
  } else if ((blooms === 'Application' && difficulty === 'Hard') || (blooms === 'HOTS' && difficulty === 'Medium')) {
    severity = 4
  } else if (blooms === 'HOTS' && difficulty === 'Hard') {
    severity = 5
  } else {
    console.log(blooms,"Blooms",difficulty,"Difficulty")
    severity = 10
  }

  if (blooms === 'Knowledge') {
    btl = 'Remember'
  } else if ((blooms = 'Understanding')) {
    btl = 'Understand'
  } else if ((blooms = 'Application')) {
    btl = 'Apply'
  } else if ((blooms = 'HOTS')) {
    btl = 'Evaluate'
    // Analyze
  } else {
    btl = 'Create'
  }
  return { btl, severity }
}
